<template>
  <v-row no-gutters>
    <feature-card-basic
      v-if="isHistoryVisible"
      ref="featureCard"
      :layer="layer"
      :object-extras-tabs="['notes']"
      :icons-to-show="['showNotes']"
      hide-dots-items
      hide-feature-watcher
    />
  </v-row>
</template>

<script>
import { get } from 'vuex-pathify';

import FeatureCardBasic from '@/components/FeatureCardBasic';

export default {
  name: 'FeatureCardHistory',
  components: { FeatureCardBasic },
  props: {
    layer: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    isSuperAdminEnabled: get('admin/additionalModules@HISTORY.enabled'),
    modulesPermission: get('users/toolsPermissions@HISTORY.main_value'),
    isHistoryVisible() {
      return this.isSuperAdminEnabled && this.modulesPermission;
    },
  },
};
</script>
